import Brands from '../views/brands';
import Catalogue from '../views/catalogue';
import CategoryType from '../views/categoryType';
import CreateProduct from '../views/createProduct';
import LogIn from '../views/logIn';
import Pills from '../views/pills';
import Shopping from '../views/shopping/Shopping';
import StockOrdersModule from '../views/stockOrdersModule/StockOrdersModule';
import { OrderDetailInternalCard } from '../views/orders/OrderDetailInternalCard';
import { BlogListing } from '../views/blogModule';
import { BlogForm } from '../views/blogModule/BlogForm';
import { ServicesModule } from '../views/services';
import { Bussines, OrganizationDetail } from '../views/business';
import { CountriesList as CountriesListLegacy } from '../views/countriesList';
import CountriesModule from '../views/countriesModule/CountriesModule';
import LogisticServiceDetailsView from '../views/LogisticServices/LogisticServiceDetailsView/LogisticServiceDetailsView';
import BackofficeConfiguration from '../views/backofficeConfiguration/BackofficeConfiguration';
import UnauthorizedView from '../views/unauthorized/UnauthorizedView';
import { OpsSupport } from '../views/OpsSupport';
import Dashboard from '../views/dashboard/Dashboard';
import UserAccount from '../views/UserAccount/UserAccount';
import ToolsModuleListing from '../views/ProductsModule/ProductsModuleListing/ToolsModuleListing';
import CreateNewOrderStock from '../views/stockOrdersModule/components/CreateNewOrderStock/CreateNewOrderStock';
import StockOrderDetail from '../views/stockOrders/StockOrderDetail/StockOrderDetail';
import TypeOfCharge from '../views/bulkUpload/TypeOfCharge/TypeOfCharge';
import UploadCatalog from 'views/bulkUpload/UploadCatalog/UploadCatalog';
import { DownloadUploadCatalog } from 'views/bulkUpload/DownloadUploadCatalog/DownloadUploadCatalog';
import UploadOrders from 'views/bulkUpload/UploadOrders/UploadOrders';
import DownloadUploadOrders from 'views/bulkUpload/DownloadUploadOrders/DownloadUploadOrders';
import LogisticServiceEdition from 'views/LogisticServices/LogisticServiceEdition/LogisticServiceEdition';
import OrderPriceEdition from 'views/orders/OrderPriceEdition/OrderPriceEdition';
import TrackingOrder from 'views/TrackingOrder/TrackingOrder';
import Announcements from '../views/announcements/Announcements';
import BillingModuleListing from '../views/BillingModule/BillingModuleListing';
import { DonwloadUploadQuotes } from 'views/bulkUpload/DonwloadUploadQuotes/DonwloadUploadQuotes';
import { QuoteScreen } from 'views/Quote/QuoteScreen/QuoteScreen';
import QuoteDetails from 'views/Quote/QuoteDetails/QuoteDetails';
import QuoteEditor from '../views/Quote/QuoteEditor/QuoteEditor';
import UploadQuotes from 'views/bulkUpload/UploadQuotes/UploadQuotes';

export interface Route {
  layout:
    | 'catalog'
    | 'auth'
    | 'category'
    | 'brand'
    | 'order'
    | 'stock'
    | 'organization'
    | 'blog'
    | 'logistic-service'
    | 'billing'
    | 'country'
    | 'configuration'
    | 'unauthorized'
    | 'ops-support'
    | 'dashboard'
    | 'account'
    | 'tools'
    | 'bulk-upload'
    | 'tracking-order'
    | 'announcement'
    | 'quote';
  path?: string;
  name: string;
  icon?: React.ComponentType<unknown>;
  component: React.ComponentType<unknown>;
  hidden?: boolean;
  label: string;
}
const catalogueRoutes: Route[] = [
  {
    component: Catalogue,
    name: 'catalogueList',
    label: 'catalogue List',
    layout: 'catalog',
    path: '/product-list'
  },
  {
    component: CategoryType,
    name: 'categoryType',
    label: 'category Type',
    layout: 'catalog',
    path: '/category-type'
  },
  {
    component: CreateProduct,
    name: 'createProduct',
    label: 'create Product',
    layout: 'catalog',
    path: '/create-product/:categoryId'
  }
];

const authRoutes: Route[] = [
  {
    component: LogIn,
    name: 'LogIn',
    label: 'LogIn',
    layout: 'auth',
    path: '/login'
  }
];

const unathorizedRoutes: Route[] = [
  {
    component: UnauthorizedView,
    name: 'Unauthorized',
    label: 'Unauthorized',
    layout: 'unauthorized',
    path: ''
  }
];

const pillRoutes: Route[] = [
  {
    component: Pills,
    name: 'ModifyPills',
    label: 'ModifyPills',
    layout: 'category',
    path: '/modify-pills'
  }
];

const brandsRoutes: Route[] = [
  {
    component: Brands,
    name: 'ListBrands',
    label: 'ListBrands',
    layout: 'brand',
    path: '/list'
  }
];

const ordersRoutes: Route[] = [
  {
    component: Shopping,
    name: 'Orders Shooping',
    label: 'Orders Shooping',
    layout: 'order',
    path: '/shopping'
  },
  {
    component: StockOrderDetail,
    name: 'Stock Order Detail',
    label: 'Stock Order Detail',
    layout: 'stock',
    path: '/details/:uuid'
  },
  {
    component: OrderDetailInternalCard,
    name: 'Order Details Internal Card',
    label: 'Order Details',
    layout: 'order',
    path: '/details/:orderId'
  },
  {
    component: OrderPriceEdition,
    name: 'Order Price Edition',
    label: 'Order Price Edition',
    layout: 'order',
    path: '/price-edition/:orderId'
  }
];

const stockOrdersRoutes: Route[] = [
  {
    component: StockOrdersModule,
    name: 'Stock Orders List',
    label: 'Stock Orders List',
    layout: 'stock',
    path: '/list-stock'
  },
  {
    component: CreateNewOrderStock,
    name: 'Create New Order Stock',
    label: 'Create New Order Stock',
    layout: 'stock',
    path: '/create-new-order-stock'
  },
  {
    component: StockOrderDetail,
    name: 'Stock Order Detail',
    label: 'Stock Order Detail',
    layout: 'stock',
    path: '/details/:uuid'
  }
];

const bussinesRoutes: Route[] = [
  {
    component: Bussines,
    name: 'Bussines Main',
    label: 'Bussines Main',
    layout: 'organization',
    path: '/list'
  },
  {
    component: OrganizationDetail,
    name: 'Business Internal',
    label: 'Business Internal',
    layout: 'organization',
    path: '/details/:organizationId'
  }
];

const blogRoutes: Route[] = [
  {
    component: BlogListing,
    name: 'Blog Main',
    label: 'Blog Main',
    layout: 'blog',
    path: '/list'
  },
  {
    component: BlogForm,
    name: 'Blog Form',
    label: 'Blog Form',
    layout: 'blog',
    path: '/new-entry/:blogId?'
  }
];

const servicesRoutes: Route[] = [
  {
    component: ServicesModule,
    name: 'Services Main',
    label: 'Services Main',
    layout: 'logistic-service',
    path: '/listing'
  },
  {
    component: LogisticServiceDetailsView,
    name: 'Logistic Service Details',
    label: 'Logistic Service Details',
    layout: 'logistic-service',
    path: '/details/:logisticServiceId'
  },
  {
    component: LogisticServiceEdition,
    name: 'Logistic Service Edition',
    label: 'Logistic Service Edition',
    layout: 'logistic-service',
    path: '/edit/:logisticServiceId'
  }
];

const countriesListLegacyRoutes: Route[] = [
  {
    component: CountriesListLegacy,
    name: 'Countries List',
    label: 'Countries List',
    layout: 'country',
    path: '/listing'
  }
];

const countriesListRoutes: Route[] = [
  {
    component: CountriesModule,
    name: 'Countries List',
    label: 'Countries List',
    layout: 'country',
    path: '/listing'
  }
];

const configurationRoutes: Route[] = [
  {
    component: BackofficeConfiguration,
    name: 'Backoffice configuration',
    label: 'Backoffice configuration',
    layout: 'configuration',
    path: '/details'
  }
];

const opsSupportRoutes: Route[] = [
  {
    component: OpsSupport,
    name: 'Backoffice opsSupport',
    label: 'Backoffice opsSupport',
    layout: 'ops-support',
    path: '/start'
  }
];

const dashboardRoutes: Route[] = [
  {
    component: Dashboard,
    name: 'Dashboard',
    label: 'Dashboard',
    layout: 'dashboard',
    path: '/dashboard'
  }
];

const accountRoutes: Route[] = [
  {
    component: UserAccount,
    name: 'Account Management',
    label: 'Account Management',
    layout: 'account',
    path: '/details'
  }
];

const toolsRoutes: Route[] = [
  {
    component: ToolsModuleListing,
    name: 'Tools Listing',
    label: 'Tools Listing',
    layout: 'tools',
    path: '/listing'
  }
];

const bulkUploadRoutes: Route[] = [
  {
    component: TypeOfCharge,
    name: 'Bulk Upload',
    label: 'Bulk Upload',
    layout: 'bulk-upload',
    path: '/type-of-charge'
  },
  {
    component: UploadCatalog,
    name: 'Upload catalogue',
    label: 'Upload catalogue',
    layout: 'bulk-upload',
    path: '/catalog/upload'
  },
  {
    component: DownloadUploadCatalog,
    name: 'Download catalog',
    label: 'Download catalog',
    layout: 'bulk-upload',
    path: '/catalog/download'
  },
  {
    component: UploadOrders,
    name: 'Upload orders',
    label: 'Upload orders',
    layout: 'bulk-upload',
    path: '/orders/upload'
  },
  {
    component: DownloadUploadOrders,
    name: 'Download orders',
    label: 'Download orders',
    layout: 'bulk-upload',
    path: '/orders/download'
  },
  {
    component: UploadQuotes,
    name: 'Upload quotes',
    label: 'Upload quotes',
    layout: 'bulk-upload',
    path: '/quotes/upload'
  },
  {
    component: DonwloadUploadQuotes,
    name: 'Download quotes',
    label: 'Download quotes',
    layout: 'bulk-upload',
    path: '/quotes/download'
  }
];

const trackingOrderRoutes: Route[] = [
  {
    component: TrackingOrder,
    name: 'Tracking Order',
    label: 'Tracking Order',
    layout: 'tracking-order',
    path: '/main'
  }
];

const announcementsRoutes: Route[] = [
  {
    component: Announcements,
    name: 'Announcement',
    label: 'Announcement',
    layout: 'announcement',
    path: ''
  }
];

const billingRoutes: Route[] = [
  {
    component: BillingModuleListing,
    name: 'Billing Listing',
    label: 'Billing Listing',
    layout: 'billing',
    path: '/listing'
  }
];

const quoteRoutes: Route[] = [
  {
    component: QuoteScreen,
    name: 'Quote',
    label: 'Quote',
    layout: 'quote',
    path: '/list'
  },
  {
    component: QuoteDetails,
    name: 'Quote Details',
    label: 'Quote Details',
    layout: 'quote',
    path: '/details/:id'
  },
  {
    component: QuoteEditor,
    name: 'Quote Editor',
    label: 'Quote Editor',
    layout: 'quote',
    path: '/edit/:id'
  }
];

export {
  catalogueRoutes,
  authRoutes,
  pillRoutes,
  brandsRoutes,
  ordersRoutes,
  bussinesRoutes,
  blogRoutes,
  servicesRoutes,
  countriesListLegacyRoutes,
  countriesListRoutes,
  configurationRoutes,
  unathorizedRoutes,
  opsSupportRoutes,
  dashboardRoutes,
  accountRoutes,
  toolsRoutes,
  bulkUploadRoutes,
  stockOrdersRoutes,
  trackingOrderRoutes,
  announcementsRoutes,
  billingRoutes,
  quoteRoutes
};
